const localises = document.querySelectorAll("[data-js-localise]");

document.addEventListener("click", (event) => {
  localises.forEach((localise) => {
    const details = localise.querySelector("details");

    if (!details?.open || localise.contains(event.target)) return;

    details.open = false;
  });
});

// const localise = document.querySelector("[data-js-localise]");
// const details = localise?.querySelector("details");

// if (!localise) return;

// if (details) {
//   document.addEventListener("click", (event) => {
//     if (!details.open || localise.contains(event.target)) return;
//
//     details.open = false;
//   });
// }
